<template>
  <div id="app" v-title :data-title="$appName + '系统'">
    <router-view />
    <DynamicIsland />
  </div>
</template>

<script>
import DynamicIsland from '@/views/components/DynamicIsland.vue'
export default {
  name: 'App',
  components: {
    DynamicIsland
  },
  data() {
    return {
      pollingTimer: null,
      notifiedTaskIds: new Set(),
      currentRole: '',
      currentUser: null
    };
  },
  mounted() {
    this.initUserAndPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    initUserAndPolling() {
      try {
        const cachedDataStr = localStorage.getItem('loginResponse');
        if (cachedDataStr) {
          const cachedData = JSON.parse(cachedDataStr);
          this.currentUser = cachedData;
          this.currentRole = cachedData.role;

          if (this.currentRole === 'admin') {
            this.startPolling();
          }
        }
      } catch (e) {
        console.error('解析用户信息失败', e);
      }
    },

    startPolling() {
      this.checkUnreadTasks();
      this.pollingTimer = setInterval(() => {
        this.checkUnreadTasks();
      }, 5000);
    },

    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },

    checkUnreadTasks() {
      const payload = {
        id: this.currentUser.id,
        name: this.currentUser.name,
        role: this.currentUser.role,
        bu: this.currentUser.bu
      };
      this.$request.post('/buUserTask/unread', payload).then(res => {
        if (res.code === 200) {
          const tasks = res.data.list || [];

          if (tasks.length === 0) return;

          tasks.forEach(task => {
            if (!this.notifiedTaskIds.has(task.id)) {
              this.showTaskNotification(task);
              this.notifiedTaskIds.add(task.id);
            }
          });
        }
      }).catch(e => {
        console.error("轮询请求异常:", e);
      });
    },

    showTaskNotification(task) {
      const isSuccess = task.status && task.status.includes('成功');
      this.$notify({
        title: isSuccess ? '任务执行完成' : '任务执行异常',
        dangerouslyUseHTMLString: true,
        message: `
          <div style="font-size: 14px; color: #606266;">
            <p style="margin: 0; font-weight: 500; color: #303133;">${task.name}</p>
            <p style="margin: 4px 0 0 0; color: ${isSuccess ? '#67C23A' : '#F56C6C'}">
              <i class="${isSuccess ? 'el-icon-circle-check' : 'el-icon-warning'}"></i>
              ${task.result || '暂无详细结果'}
            </p>
            <p style="margin: 4px 0 0 0; font-size: 12px; color: #909399;">
              ${this.formatTime(task.stopTime)}
            </p>
          </div>
        `,
        type: isSuccess ? 'success' : 'error',
        duration: 4500,
        position: 'bottom-right',
        offset: 50
      });
    },

    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      if (isNaN(date.getTime())) return timeStr;
      date.setHours(date.getHours()  - date.getTimezoneOffset() / 60);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

body {
  margin: 0;
}

nav {
  padding: 0px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.el-message {
  top: 80px !important; 
  transition: top 0.4s;
  z-index: 3000 !important;
}
</style>